<template>
  <div>
    <div class="filter-region">
      <PartSearchAdvancedFilters v-if="search"
                        :keyword.sync="search.keyword"
                        :matches.sync="search.matches"
                        :terms.sync="search.terms"
                        :specs.sync="search.specs"
                        :exists.sync="search.exists"
                        :aggs.sync="search.aggs"
                        ref="searchFilter"
                        @onSearch="handleSearch"></PartSearchAdvancedFilters>
    </div>
    <Tabs type="card" value="pangu" id="tab-wrapper">
      <TabPane :label="panguTabLabel" name="pangu">
        <PanguComponents ref="panguComponents"
                          :showCheckbox="showPickButton"
                          :components.sync="selectedPanguComponents"
                          :filters="search"
                          @onComponentsLoaded="hanldePanguComponentsLoaded">
        </PanguComponents>
      </TabPane>
      <TabPane :label="octopartTabLabel" name="octopart">
        <OctopartSearchParts ref="octopartComponents"
                             :showTransferButton="showOctopartTransferButton"
                             :components.sync="selectedOctopartComponents"
                             :mpn="search.matches.mpn"
                             :brand="search.matches.brand"
                             @onTransfered="handleOctopartComponentTransfered">
        </OctopartSearchParts>
      </TabPane>
      <div slot="extra">
        <Button icon="md-add" v-if="showPickButton" type="primary" @click="handlePickComponents" id="pick-item">Pick
          Selected components
        </Button>
        <Button icon="ios-add" v-if="!showPickButton" type="primary" @click="handleAddNewComponent" id="add-component">
          {{ $t('electronic.button.new_electronic_part') }}
        </Button>
      </div>
    </Tabs>
  </div>
</template>

<script>
import OctopartSearchParts from './octopart-search-parts'
import PanguComponents from './pangu-components'
import PartSearchAdvancedFilters from './part-search-advanced-filters'

import Vue from 'vue'
import 'xe-utils'
import VXETable from 'vxe-table'
import 'vxe-table/lib/index.css'

Vue.use(VXETable)

export default {
  name: 'PartSearchWidget',
  components: {
    PanguComponents,
    OctopartSearchParts,
    PartSearchAdvancedFilters
  },
  props: {
    components: {
      type: Array
    },
    autoload: {
      type: Boolean,
      default: true
    },
    filters: {
      type: Object
    },
    showOctopartTransferButton: {
      type: Boolean,
      default: true
    },
    showPickButton: {
      type: Boolean,
      default: false
    },
    componentType: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      selectedPanguComponents: [],
      selectedOctopartComponents: [],
      panguTabLabel: (h) => {
        return h('div', [
          h('span', 'Pangu    '),
          h('Badge', {
            props: {
              count: this.showPickButton ? this.selectedPanguComponents.length : 0
            }
          })
        ])
      },
      octopartTabLabel: (h) => {
        return h('div', [
          h('span', 'Octopart    '),
          h('Badge', {
            props: {
              count: this.showPickButton ? this.selectedOctopartComponents.length : 0
            }
          })
        ])
      },
      search: {
        keyword: '',
        matches: {
          mpn: null,
          brand: null
        },
        terms: { moderation_state: null },
        specs: {},
        exists: {},
        aggs: {}
      }
    }
  },
  mounted () {
    this.init(this.filters)
  },
  methods: {
    async init (filters) {
      this.selectedPanguComponents = []
      this.selectedOctopartComponents = []
      if (this.componentType) {
        this.search.terms.component_type = this.componentType
      }
      this.search = {
        keyword: '',
        matches: {
          mpn: null,
          brand: null
        },
        terms: { moderation_state: 'reviewed' },
        specs: {},
        exists: {},
        aggs: {}
      }
      if (filters) {
        this.search = _.merge(this.search, filters)
        this.$refs.searchFilter.setFilterFormValue(this.search)
      }
      if (this.autoload) {
        this.handleSearch(this.search)
      }
    },
    handleSearch (filters) {
      this.$refs.panguComponents.currentPage = 1
      this.$refs.panguComponents.handleLoadParts()
      if (this.search.matches.mpn) {
        this.$refs.octopartComponents.handleSearch(this.search.matches.mpn, this.search.matches.brand)
      }
    },
    async handlePickComponents () {
      let components = _.cloneDeep(this.selectedPanguComponents)
      if (this.selectedOctopartComponents.length > 0) {
        let transferedComponents = await this.$refs.octopartComponents.handleTransferComponent()
        if (transferedComponents) {
          components = _.uniqBy(_.concat(components, transferedComponents), 'id')
        }
      }
      this.$emit('update:components', components)
      this.$emit('on-pick', components)
    },
    hanldePanguComponentsLoaded (result) {
      if (result.aggs) {
        this.$refs.searchFilter.setAggResult(result.aggs)
      }
    },
    handleOctopartComponentTransfered (res) {
      if (res && res.length > 0 && !this.showPickButton) {
        this.$Notice.info({
          title: `Transferred ${res.length} components from Octopart`,
          render: (h) => {
            return _.map(res, component => {
              return h('p', `mpn: ${component.mpn}  , brand: ${component.brand}`)
            })
          },
          duration: 0
        })

        this.$router.push({ name: 'menu.electronic_part.edit', params: { partId: res[0].id } })
      }
    },
    handleAddNewComponent () {
      this.$router.push({ name: 'menu.electronic_part.new' })
    }
  }
}
</script>

<style lang="less" scoped>
  .search-region {
    margin-bottom: 50px;

    .search {
      position: relative;
      margin: 0 auto;
      max-width: 630px;
    }
  }

  .actions {
    text-align: right;
  }

  .search-form-buttons {
    margin-top: 24px;
  }

  #tab-wrapper {
    margin-top: 10px;
  }

  #pick-item {
    float: right;
    margin-left: 10px;
  }

  #add-component {
    float: right;
    margin-left: 10px;
  }

  .ivu-tabs-tabpane .content {
    padding: 0 !important;
  }
</style>
